import React, { useState } from 'react';
import { sb } from '../services/supabase';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const login = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true); setError('');
    const { error } = await sb.auth.signInWithPassword({ email, password });
    if (error) { setError(error.message); setLoading(false); }
  };

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      {/* Grid background */}
      <div style={{ position: 'fixed', inset: 0, overflow: 'hidden', opacity: 0.4 }}>
        {Array.from({length:12}).map((_,i) => <div key={`v${i}`} style={{ position: 'absolute', left: `${i*9}%`, top: 0, bottom: 0, width: 1, background: 'var(--border)' }} />)}
        {Array.from({length:16}).map((_,i) => <div key={`h${i}`} style={{ position: 'absolute', top: `${i*7}%`, left: 0, right: 0, height: 1, background: 'var(--border)' }} />)}
      </div>
      <div style={{ position: 'relative', width: '100%', maxWidth: 400 }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 40 }}>
          <div style={{ width: 64, height: 64, borderRadius: 20, background: 'var(--accent)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: 32, marginBottom: 16 }}>⏱</div>
          <div style={{ fontSize: 32, fontWeight: 800, letterSpacing: -1 }}>ClockedIQ</div>
          <div style={{ color: 'var(--muted)', fontSize: 13, marginTop: 4 }}>Intelligent Attendance · Effortless Payroll</div>
        </div>
        {/* Card */}
        <div style={{ background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 20, padding: 32 }}>
          <div style={{ fontSize: 18, fontWeight: 800, marginBottom: 24 }}>Sign in</div>
          <form onSubmit={login} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <div>
              <label style={{ fontSize: 11, fontWeight: 700, color: 'var(--muted)', textTransform: 'uppercase', letterSpacing: 0.5, display: 'block', marginBottom: 6 }}>Email</label>
              <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@company.com" required
                style={{ width: '100%', background: 'var(--bg)', border: '1px solid var(--border)', borderRadius: 8, padding: '12px', fontSize: 14, color: 'var(--text)', outline: 'none', boxSizing: 'border-box' }} />
            </div>
            <div>
              <label style={{ fontSize: 11, fontWeight: 700, color: 'var(--muted)', textTransform: 'uppercase', letterSpacing: 0.5, display: 'block', marginBottom: 6 }}>Password</label>
              <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" required
                style={{ width: '100%', background: 'var(--bg)', border: '1px solid var(--border)', borderRadius: 8, padding: '12px', fontSize: 14, color: 'var(--text)', outline: 'none', boxSizing: 'border-box' }} />
            </div>
            {error && <div style={{ background: '#FF6B6B15', border: '1px solid #FF6B6B30', borderRadius: 8, padding: '10px 14px', color: 'var(--danger)', fontSize: 13 }}>{error}</div>}
            <button type="submit" disabled={loading}
              style={{ background: 'var(--accent)', color: '#000', border: 'none', borderRadius: 10, padding: 14, fontSize: 15, fontWeight: 800, cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1, fontFamily: 'var(--font)' }}>
              {loading ? 'Signing in...' : 'Sign In →'}
            </button>
          </form>
        </div>
        <div style={{ textAlign: 'center', marginTop: 24, color: 'var(--muted)', fontSize: 12 }}>Powered by Saskey Innovations</div>
      </div>
    </div>
  );
}
